import { RefreshCwIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import type { ManagedCustomDashboardTab } from '@/lib/api/custom-dashboard';
import { DATA_UPDATE_BLOCKER_REASONS, dataUpdateBlocker } from './dataUpdateAvailability';
import type { DataUpdateRequestTarget } from './dataUpdateTargets';

export interface TabDataUpdateControlsProps {
  tab: ManagedCustomDashboardTab;
  /** 「データ更新」ボタン押下時にダイアログを開くための要求。ダイアログ本体は呼び出し元が持つ。 */
  onRequestUpdate: (target: DataUpdateRequestTarget) => void;
}

/**
 * タブ行の「データ更新」ボタン。状態の表示は `TabDataUpdateStatus`（データ更新の欄）が受け持つ。
 * ダイアログ本体（DataUpdateDialog）は remount で消えないよう `TabConfigScreen` に持ち上げてある。
 */
export function TabDataUpdateControls({ tab, onRequestUpdate }: TabDataUpdateControlsProps) {
  const blocker = dataUpdateBlocker(tab);

  const handleClick = () => {
    if (tab.activeRevision === null) return;
    onRequestUpdate({
      tabId: tab.tabId,
      name: tab.name,
      expectedActiveRevision: tab.activeRevision,
    });
  };

  return (
    // shadcn Button は disabled 時に pointer-events:none になり title が出ないため、
    // ラップする span 側に title を持たせる。
    <span
      title={blocker === null ? undefined : DATA_UPDATE_BLOCKER_REASONS[blocker]}
      className="inline-flex"
    >
      <Button
        size="sm"
        variant="outline"
        aria-label={`${tab.name}のデータを更新`}
        disabled={blocker !== null}
        onClick={handleClick}
      >
        <RefreshCwIcon size={16} aria-hidden />
        データ更新
      </Button>
    </span>
  );
}
